import React from "react";
import {Redirect} from "react-router-dom";

import Inbox from "../pages/Inbox/index";
import SimpleFiles from "../pages/SimpleFiles/index";

import Files from "../pages/Files/index";
import FJSearch from "../pages/Search/index";

import Dashboard from "../pages/Dashboard/index";

import Companies from "../pages/Companies/index";
import Sections from "../pages/Sections/index";
import Segments from "../pages/Segments/index";
import Users from "../pages/Users/index";
import Groups from "../pages/Groups/index";
import Notifications from "../pages/Notifications/index";

import EnumPermissions from "../pages/Enums/Permissions/index";
import EnumVersions from "../pages/Enums/Versions/index";
import EnumStorages from "../pages/Enums/Storages/index";

import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";

import PagesMaintenance from "../pages/Utility/pages-maintenance";
import Pages404 from "../pages/Utility/pages-404";

const authProtectedRoutes = [
  {path: "/simple-inbox", component: Inbox},
  {path: "/simple-files", component: SimpleFiles},

  {path: "/inbox", component: Inbox},
  {path: "/files", component: Files},
  {path: "/search", component: FJSearch},

  {path: "/dashboard", component: Dashboard},

  {path: "/companies", component: Companies},
  {path: "/sections", component: Sections},
  {path: "/segments", component: Segments},
  {path: "/users", component: Users},
  {path: "/groups", component: Groups},
  {path: "/notifications", component: Notifications},

  {path: "/enums/permissions", component: EnumPermissions},
  {path: "/enums/versions", component: EnumVersions},
  {path: "/enums/storages", component: EnumStorages},

  {path: "/", component: () => <Redirect to="/inbox"/>},

  {path: "*", exact: true, component: () => <Redirect to="/pages-404"/>},
];

const publicRoutes = [
  {path: "/logout", component: Logout},
  {path: "/login", component: Login},

  {path: "/pages-maintenance", component: PagesMaintenance},
  {path: "/pages-404", component: Pages404},
];

export {authProtectedRoutes, publicRoutes};